import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';
import { PoolModel } from '../../sections/types/PoolModel';

export interface IAssignClusterToPoolParams {
    poolId: string;
    clusterId: string;
}

export interface IAssignClusterToPoolResult extends IResult {
  success?: {
    pool: PoolModel;
};
  error?: BaasEdgePoolError;
}

export class AssignClusterToPoolRequest extends Request<IAssignClusterToPoolParams, IAssignClusterToPoolResult> {
  constructor(params: IAssignClusterToPoolParams) {
    super('assignBaasClusterToPool', params);
  }
}
